const ROUTERS = {
  LANDING1: '/landing-1',
  LANDING2: '/landing-2',
  SELFCAREJOURNAL: '/selfcarejournal',
  SAFEPLACETOVENT1: '/landing/a-safe-place-to-vent'
};

export default ROUTERS;
